import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { navigateToStep } from 'actions/onlineBooking/actions/OnlineBookingFlowActions';
import { clearPurchaseCart } from 'actions/purchases/PurchasesActions';
import { dogFistBump } from 'assets/images';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { TwoColumnsLayout } from 'components/Layout/TwoColumns/TwoColumnsLayout';
import { OnlineBookingHeader } from 'components/OnlineBooking/Header/OnlineBookingHeader';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { dispatch } from 'store';
import { OnlineBookingStep } from 'types/OnlineBooking';
import { goToPetParentPortal } from 'utils/petParentPortal';
import classes from './OnlineBookingPurchaseSuccessStep.module.scss';

export const OnlineBookingPurchaseSuccessStep: React.FC = () => {
    const { slug } = useMarketplace();

    const backToOnlineBookingHandler = () => {
        dispatch(clearPurchaseCart());
        dispatch(navigateToStep(OnlineBookingStep.ServiceCategory));
    };

    return (
        <TwoColumnsLayout header={<OnlineBookingHeader />}>
            <LeftColumn contentClassName={classes.content}>
                <FontAwesomeIcon icon={faCircleCheck} className={classes.icon} />

                <h1 className="h2">Your purchase is complete!</h1>

                <p className={classes.description}>
                    Your package or membership is ready to use. You can view the details anytime in
                    the Pet Parent Portal.
                </p>

                <Button className={classes.backAction} onClick={backToOnlineBookingHandler}>
                    Go Back to Online Booking
                </Button>

                <Button
                    variant="underlined-link"
                    className={classes.portalLink}
                    onClick={() => goToPetParentPortal(slug)}
                >
                    Go to Pet Parent Portal
                </Button>

                <div className="mt-4">
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <div className={classes.imageColumn}>
                <img src={dogFistBump} alt="Dog fist bump" className={classes.image} />
            </div>
        </TwoColumnsLayout>
    );
};
